import { render } from "./SeStdTaxForm1120s.vue?vue&type=template&id=71b105df"
import script from "./SeStdTaxForm1120s.vue?vue&type=script&lang=js"
export * from "./SeStdTaxForm1120s.vue?vue&type=script&lang=js"

import "./SeStdTaxForm1120s.vue?vue&type=style&index=0&id=71b105df&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__